import { Box, Skeleton } from "@mui/material";
import { EMPTY_SX } from "../../utils/empty-sx";

import type { LoadableTemplateImage } from "../generic/atoms/types/template";
import type { BoxProps } from "@mui/material";
import type { FC } from "react";

export const TemplateCarouselImage: FC<
  BoxProps & { selected?: boolean; image?: LoadableTemplateImage }
> = ({ image, selected = false, sx = EMPTY_SX, ...props }) => (
  <Box
    data-analytics-id="template-carousel-image"
    role="button"
    title={(image?.state === "hasData" && image.data?.style?.value) || ""}
    {...props}
    sx={[
      {
        boxShadow: 2,
      },
      (theme) => ({
        boxSizing: "content-box",
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: selected ? theme.palette.primary.main : "divider",
        cursor: props.onClick ? "pointer" : "default",
        backgroundImage:
          image?.state === "hasData" && image.data?.url.state === "hasData"
            ? `url(${image.data?.url.data})`
            : "none",
        backgroundSize: "cover",
        position: "relative",
        "&:hover": {
          borderColor: theme.palette.primary.main,
        },
        borderRadius: "8px",
      }),
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {(image?.state !== "hasData" || image.data?.url.state !== "hasData") && (
      <Skeleton sx={{ width: "100%", height: "100%" }} variant="rectangular" />
    )}
  </Box>
);
